import { Button } from "../Button/Button";
import { CaretLeftIcon } from "../icons/CaretLeftIcon";
import { CaretRightIcon } from "../icons/CaretRightIcon";

export function CarouselButton({
  kind,
  className,
  onClick,
  disabled,
}: {
  kind: "previous" | "next";
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      className={className}
      onClick={onClick}
      variant={"secondary-dark"}
      ariaLabel={
        kind === "previous" ? "Previous" : kind === "next" ? "Next" : undefined
      }
      shape="carousel"
      disabled={disabled}
    >
      {kind === "previous" && <CaretLeftIcon />}
      {kind === "next" && <CaretRightIcon />}
    </Button>
  );
}
